import { BrowserRouter, Route, Routes } from "react-router-dom";
import LoginPage from "./auth/login-page/LoginPage";
import RootLayout from "./(layouts)/RootLayout";
import LoginAdminPage from "./auth/login-page/LoginAdminPage";
import CheckAuthen from "./auth/check-authen/CheckAuthen";
import NotFoundPage from "./auth/not-fount-page/NotFoundPage";
import DashboardLayout from "./(layouts)/DashboardLayout";
import DashboardHomePage from "./(dashboards)/dashboard-home/DashboardHomePage";
import DashboardSelectRegisterPage from "./(dashboards)/dashboard-select-register/DashboardSelectRegisterPage";
import DashboardSelectNotRegisterPage from "./(dashboards)/dashboard-select-not-register/DashboardSelectNotRegisterPage";
import DashboardConfrimRegisterPage from "./(dashboards)/dashboard-confrim-register/DashboardConfrimRegisterPage";
import DashboardConfrimNotRegisterPage from "./(dashboards)/dashboard-confrim-not-register/DashboardConfrimNotRegisterPage";
import DashboardRegisterDetailPage from "./(dashboards)/dashboard-register-detail/DashboardRegisterDetailPage";
import DashboardUsePaymentPage from "./(dashboards)/dashboard-use-payment/DashboardUsePaymentPage";
import DashboardPaymentPage from "./(dashboards)/dashboard-payment/DashboardPaymentPage";
import AdministratorLayout from "./(layouts)/AdministratorLayout";
import AdministratorHomePage from "./(administrators)/administrator-home/AdministratorHomePage";
import AdministratorListnamePage from "./(administrators)/administrator-listname/AdministratorListnamePage";
import AdministratorCardPage from "./(administrators)/administrator-card/AdministratorCardPage";
import AdministratorClearregister from "./(administrators)/administrator-clearregister/AdministratorClearregister";
import { basename } from "./settings/linkUrl";

function App() {
  return (
    <BrowserRouter basename={basename}>
      <Routes>
        <Route path="/" element={<RootLayout />}>
          <Route index element={<LoginPage />} />
          <Route path="loginAuth" element={<LoginAdminPage />} />
          <Route
            path="creck_codepassfor/:id_no/:dd/:mm/:yy"
            element={<CheckAuthen />}
          />
        </Route>

        <Route path="dashboard" element={<DashboardLayout />}>
          <Route index element={<DashboardHomePage />} />
          <Route
            path="select-register"
            element={<DashboardSelectRegisterPage />}
          />
          <Route
            path="select-not-register"
            element={<DashboardSelectNotRegisterPage />}
          />
          <Route
            path="confrim-register"
            element={<DashboardConfrimRegisterPage />}
          />
          <Route
            path="confrim-not-register"
            element={<DashboardConfrimNotRegisterPage />}
          />
          <Route
            path="register-detail"
            element={<DashboardRegisterDetailPage />}
          />
          <Route path="use-payment" element={<DashboardUsePaymentPage />} />
          <Route path="payment" element={<DashboardPaymentPage />} />
        </Route>

        <Route path="administrator" element={<AdministratorLayout />}>
          <Route index element={<AdministratorHomePage />} />
          <Route path="listname" element={<AdministratorListnamePage />} />
          <Route path="card" element={<AdministratorCardPage />} />
          <Route
            path="clearregister"
            element={<AdministratorClearregister />}
          />
        </Route>

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
